import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import styles from './WorksheetChip.module.css';

function WorksheetChip({ worksheet, compact = false, source = 'calendar', overlay = false }) {
  const navigate = useNavigate();
  const item = { ...worksheet, _itemType: 'worksheet' };
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `worksheet-${worksheet.id}`,
    data: { lesson: item, source },
  });

  const getTypeAbbrev = (type) => {
    switch (type) {
      case 'quiz': return 'Q';
      case 'homework': return 'HW';
      case 'test': return 'T';
      case 'worksheet': return 'WS';
      default: return '?';
    }
  };

  const style = {
    ...(transform ? { transform: CSS.Translate.toString(transform) } : {}),
    ...(isDragging ? { opacity: 0.3 } : {}),
  };

  if (overlay) {
    return (
      <div className={styles.chip} title={worksheet.title}>
        <span className={styles.typeIcon}>{getTypeAbbrev(worksheet.type)}</span>
        <span className={styles.title}>{worksheet.title}</span>
      </div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      className={`${styles.chip} ${isDragging ? styles.dragging : ''}`}
      style={style}
      {...attributes}
      {...listeners}
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/worksheets/${worksheet.id}/edit`);
      }}
      title={worksheet.title}
    >
      <span className={styles.typeIcon}>{getTypeAbbrev(worksheet.type)}</span>
      <span className={styles.title}>{worksheet.title}</span>
      {!compact && worksheet.gradeLevel && (
        <span className={styles.grade}>{worksheet.gradeLevel}</span>
      )}
    </div>
  );
}

export default WorksheetChip;
